"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var Icon_1 = require("../Icon");
/*eslint-disable */
/*tslint:disable */
var Error = function (props) { return (React.createElement(Icon_1.default, tslib_1.__assign({ viewBox: "0 0 15 15" }, props),
    React.createElement("g", null,
        React.createElement("g", { fill: "none", fillRule: "evenodd" },
            React.createElement("path", { fill: "currentColor", d: "M7.5 1a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13zm0-1a7.5 7.5 0 1 1 0 15 7.5 7.5 0 0 1 0-15z", fillRule: "nonzero" }),
            React.createElement("path", { fill: "currentColor", d: "M7.982 9h-.964V4h.964z" }),
            React.createElement("path", { fill: "currentColor", d: "M8 11H7v-1h1z" }))))); };
/*tslint:enable */
/*eslint-enable */
exports.default = Error;
//# sourceMappingURL=Error.js.map